import { render, staticRenderFns } from "./CragRouteAscent.vue?vue&type=template&id=46e2f185"
import script from "./CragRouteAscent.vue?vue&type=script&lang=js"
export * from "./CragRouteAscent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports